import {RailsInitializer} from '../src/default/Rails';
import {PartialsLoader} from '../src/default/PartialLoader';
import {EmailDisplay} from '../src/default/Email';
import {VideoVisibilityCheckerHandler} from '../src/default/VideoVisibilityChecker';
import {HTMLElementRatioResizer} from '../src/default/HTMLElementRatioResizer';
import {SceneCardsController} from '../src/default/SceneCardsController';
import {Toolbar} from '../src/default/Toolbar';
import {FormController} from '../src/default/Form';
import {YoutubeLiteEmbedder} from '../src/default/YoutubeLiteEmbedder';
import {CodeClipboardHandler} from '../src/default/CodeClipboardHandler';

const libsToInitialize = {
	RailsInitializer,
	PartialsLoader,
	EmailDisplay,
	VideoVisibilityCheckerHandler,
	HTMLElementRatioResizer,
	SceneCardsController,
	Toolbar,
	FormController,
	YoutubeLiteEmbedder,
	CodeClipboardHandler,
};

for (let libName of Object.keys(libsToInitialize)) {
	const lib = (libsToInitialize as any)[libName];
	lib.init();
}
